import React, {useState} from 'react'

import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import '../components/Core/AbstractGrid.scss';
import {useForm, FormProvider} from "react-hook-form";
import UiInputText from "../components/Form/UiInputText";
import Form from "../components/Form/Form";
import "./OrcamentoRapido.scss";

import Overlay from "../components/Overlay";
import {Search, Zap} from "react-feather";
import {get, post} from "../services/ApiService";
import {Util} from "../util/Util";
import {useWindowManager} from "../components/Window/WindowManager";
import {resolveWindowSize} from "../components/Window/windowTypes";
import OrcamentoForm from "./OrcamentoForm";
import {UiButton} from "../components/UiButton";

const OrcamentoRapido = (props) => {
    const windowManager = useWindowManager();
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState();
    const [message, setMessage] = useState(null);

    //const { user } = useContext(AuthProvider);

    const methods = useForm({
        defaultValues: props.data
    });
    const { handleSubmit, watch } = methods;
    const allData = watch();

    const doAction = (formData) => {
        setMessage(null);
        setLoading(true);
        doRequest('consultaFaturaList')
            .then((faturaList) => {
                setData(faturaList);
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
                setMessage(err);
            })
    }

    const getCredentials = () => {
        return {
            nrUC: allData.nrUC,
            nrDocumento: allData.nrDocumento,
        }
    }
    const doRequest = (action) => {
        return get(`/?route=celesc&action=${action}&payload=${JSON.stringify(getCredentials())}`)
            .then((response) => {
                setLoading(false);
                if (response.status === 200) {
                    if (response.data) {
                        return response.data; // resolve com os dados
                    } else {
                        throw new Error("Erro de validação. Verifique os dados digitados.");
                    }
                } else {
                    throw new Error("Erro na resposta do servidor.");
                }
            });
    }

    const actionPdf = (invoiceCode) => {
        alert(invoiceCode);
    }

    const criarOrcamentoAutomatico = (invoice) => {
        setMessage(null);

        let windowId = null;

        const WindowContentWrapper = (wProps) => {
            const handleSubmit = async (formData) => {
                windowManager.updateWindowData(windowId, wProps.data, true);
                try {
                    const response = await post('/?route=orcamento/form&action=add', { dados: formData });
                    if (response.status === 200 && response.data?.success) {
                        windowManager.closeWindow(windowId);
                    } else {
                        alert(response.data?.message || 'Erro ao salvar');
                        windowManager.updateWindowData(windowId, wProps.data, false);
                    }
                } catch (err) {
                    alert('Erro ao salvar');
                    windowManager.updateWindowData(windowId, wProps.data, false);
                }
            };

            return (
                <OrcamentoForm
                    data={wProps.data}
                    triggerSubmit={handleSubmit}
                    triggerSubmitAsNew={handleSubmit}
                    triggerClose={() => windowManager.closeWindow(windowId)}
                />
            );
        };

        windowId = windowManager.openWindow({
            title: 'Novo Orçamento',
            component: WindowContentWrapper,
            size: resolveWindowSize('xl'),
            loading: true,
            data: null,
        });

        const payload = { nrUC: invoice.installation, invoiceCode: invoice.code };

        get(`/?route=celesc&action=orcamentoAutomatico&payload=${JSON.stringify(payload)}`)
            .then((response) => {
                if (response.status === 200 && response.data?.success) {
                    const d = response.data.dadosOrcamento;
                    windowManager.updateWindowData(windowId, {
                        engenheiro: d.engenheiro || 2,
                        ucList: d.ucList || d.cliente?.ucList || [],
                        cliente: d.cliente || {},
                    }, false);
                } else {
                    windowManager.closeWindow(windowId);
                    setMessage(response.data?.message || 'Erro ao processar fatura');
                }
            })
            .catch((err) => {
                windowManager.closeWindow(windowId);
                setMessage('Erro: ' + (err.message || err));
            });
    }

    return (
        <div className="pt-2 or-page-root">
            <Overlay show={loading} />
            <FormProvider {...methods} >
                <Form onSubmit={handleSubmit(doAction)} methods={methods}>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-3 or-form-busca">
                                <UiInputText size={12} name="nrUC" label="Unidade Consumidora"/>
                                <UiInputText size={12} name="nrDocumento" label="CPF/CNPJ"/>
                                <UiButton type="submit" variant="success"><Search size={14} /> Buscar faturas</UiButton>
                            </div>
                            <div className="col-sm-9">
                                { !Array.isArray(data) &&

                                    <div className="alert alert-info">
                                        O CPF/CNPJ é opcional, porém em casos onde o usuário <br />possuir login, sem CPF/CNPJ só vai carregar as faturas antigas.
                                    </div>

                                }

                                { Array.isArray(data) && <>
                                    {/* Desktop: tabela */}
                                    <table className="table or-table-desktop">
                                        <thead>
                                        <tr>
                                            <th>Unidade</th>
                                            <th>Período</th>
                                            <th>Vencimento</th>
                                            <th>Valor</th>
                                            <th>kWh</th>
                                            <th>Pagamento</th>
                                            <th>Dias</th>
                                            <th>Ações</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        { data?.map((invoice, index) => (
                                            <tr key={index}>
                                                <td>{invoice.installation}</td>
                                                <td>{invoice.billingPeriod}</td>
                                                <td>{invoice.dueDate}</td>
                                                <td>{Util.moeda(invoice.totalAmount)}</td>
                                                <td>{invoice.usage * 1}</td>
                                                <td>{invoice.compensation}</td>
                                                <td>{invoice.totalDays * 1}</td>
                                                <td>
                                                    <div style={{display: 'flex', gap: 4}}>
                                                        <UiButton
                                                            size="sm"
                                                            variant="primary"
                                                            onClick={() => window.open(`https://api.argonsolar.com.br/?route=celesc&action=consultarFaturaPdf&pdf&payload=${JSON.stringify({ nrUC: invoice.installation, invoiceCode: invoice.code })}`, '_blank')}
                                                        >PDF</UiButton>
                                                        {index === 0 && (
                                                            <UiButton
                                                                size="sm"
                                                                variant="success"
                                                                type="button"
                                                                onClick={() => criarOrcamentoAutomatico(invoice)}
                                                            >
                                                                <Zap size={12} /> Criar orçamento
                                                            </UiButton>
                                                        )}
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>

                                    {/* Mobile: cards */}
                                    <div className="or-cards-mobile">
                                        {data?.map((invoice, index) => (
                                            <div key={index} className={`or-card ${index === 0 ? 'or-card-recente' : ''}`}>
                                                {index === 0 && (
                                                    <div className="or-card-badge"><Zap size={11} /> Fatura mais recente</div>
                                                )}
                                                <div className="or-card-header">
                                                    <span className="or-card-periodo">{invoice.billingPeriod}</span>
                                                    <span className="or-card-valor">{Util.moeda(invoice.totalAmount)}</span>
                                                </div>
                                                <div className="or-card-grid">
                                                    <div className="or-card-item">
                                                        <span className="or-card-label">Unidade</span>
                                                        <span className="or-card-value">{invoice.installation}</span>
                                                    </div>
                                                    <div className="or-card-item">
                                                        <span className="or-card-label">Vencimento</span>
                                                        <span className="or-card-value">{invoice.dueDate}</span>
                                                    </div>
                                                    <div className="or-card-item">
                                                        <span className="or-card-label">kWh</span>
                                                        <span className="or-card-value">{invoice.usage * 1}</span>
                                                    </div>
                                                    <div className="or-card-item">
                                                        <span className="or-card-label">Dias</span>
                                                        <span className="or-card-value">{invoice.totalDays * 1}</span>
                                                    </div>
                                                    <div className="or-card-item">
                                                        <span className="or-card-label">Pagamento</span>
                                                        <span className="or-card-value">{invoice.compensation}</span>
                                                    </div>
                                                </div>
                                                <div className="or-card-actions">
                                                    <UiButton
                                                        size="sm"
                                                        variant="primary"
                                                        onClick={() => window.open(`https://api.argonsolar.com.br/?route=celesc&action=consultarFaturaPdf&pdf&payload=${JSON.stringify({ nrUC: invoice.installation, invoiceCode: invoice.code })}`, '_blank')}
                                                    >PDF</UiButton>
                                                    {index === 0 && (
                                                        <UiButton
                                                            size="sm"
                                                            variant="success"
                                                            type="button"
                                                            onClick={() => criarOrcamentoAutomatico(invoice)}
                                                        >
                                                            <Zap size={12} /> Criar orçamento
                                                        </UiButton>
                                                    )}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </> }

                                <>
                                    { message && (<div className="alert alert-info" style={{margin: '20px 0 0 0'}}>{message}</div>) }
                                </>
                            </div>
                        </div>

                    </div>

                </Form>
            </FormProvider>
        </div>
    );

}

export default OrcamentoRapido;